import { getShopProduct } from "../../app/graphql/types/getShopProduct";

export const getShopProductSuccessResponse: getShopProduct = {
  product: {
    __typename: "Product",
    id: "product-1",
    title: "Vitabiotics wellwoman max 84 tablets",
    handle: "vitabiotics-wellwoman-max-84-tablets",
    available: true,
    priceRange: {
      __typename: "PriceRange",
      maxVariantPrice: {
        __typename: "Price",
        value: 2049
      },
      minVariantPrice: {
        __typename: "Price",
        value: 2049
      }
    },
    images: [
      {
        __typename: "ProductImage",
        id: "image-1",
        src:
          "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/6002092_1024x.jpg",
        altText: ""
      }
    ],
    variants: [
      {
        __typename: "ProductVariant",
        available: true,
        id: "variant_1",
        title: "84 Tablets",
        image: null,
        options: [
          {
            __typename: "SelectedOption",
            name: "Size",
            value: "84 tablets"
          }
        ],
        price: {
          __typename: "Price",
          value: 2049
        }
      }
    ],
    options: [
      {
        __typename: "ProductOption",
        name: "Size",
        values: ["84 tablets"]
      }
    ]
  }
};

export const getShopProductWithOptionsSuccessResponse: getShopProduct = {
  product: {
    __typename: "Product",
    id: "product-1",
    title: "Fitbit Versa 3",
    handle: "fitbit-versa-3",
    available: true,
    priceRange: {
      __typename: "PriceRange",
      maxVariantPrice: {
        __typename: "Price",
        value: 32998
      },
      minVariantPrice: {
        __typename: "Price",
        value: 19998
      }
    },
    images: [
      {
        __typename: "ProductImage",
        id: "image-1",
        src:
          "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/7375512_1024x.jpg",
        altText: ""
      }
    ],
    variants: [
      {
        __typename: "ProductVariant",
        available: true,
        id: "variant_1",
        title: "Black",
        image: null,
        options: [
          {
            __typename: "SelectedOption",
            name: "Size",
            value: "Black"
          }
        ],
        price: {
          __typename: "Price",
          value: 21998
        }
      },
      {
        __typename: "ProductVariant",
        available: true,
        id: "variant_2",
        title: "Pink Clay/Soft Gold",
        image: null,
        options: [
          {
            __typename: "SelectedOption",
            name: "Size",
            value: "Pink Clay/Soft Gold"
          }
        ],
        price: {
          __typename: "Price",
          value: 19998
        }
      },
      {
        __typename: "ProductVariant",
        available: false,
        id: "variant_3",
        title: "Pink Clay/Soft Gold",
        image: null,
        options: [
          {
            __typename: "SelectedOption",
            name: "Size",
            value: "Midnight/Soft Gold"
          }
        ],
        price: {
          __typename: "Price",
          value: 32998
        }
      }
    ],
    options: [
      {
        __typename: "ProductOption",
        name: "Size",
        values: ["Black", "Pink Clay/Soft Gold", "Midnight/Soft Gold"]
      }
    ]
  }
};

export const getShopProductWithMultipleOptionsSuccessResponse: getShopProduct = {
  product: {
    __typename: "Product",
    id: "product-1",
    title: "Fitbit Versa 3",
    handle: "fitbit-versa-3",
    available: true,
    priceRange: {
      __typename: "PriceRange",
      maxVariantPrice: {
        __typename: "Price",
        value: 32998
      },
      minVariantPrice: {
        __typename: "Price",
        value: 19998
      }
    },
    images: [
      {
        __typename: "ProductImage",
        id: "image-1",
        src:
          "https://cdn.shopify.com/s/files/1/0257/1046/0991/products/7375512_1024x.jpg",
        altText: ""
      }
    ],
    variants: [
      {
        __typename: "ProductVariant",
        available: true,
        id: "variant_1",
        title: "Black",
        image: null,
        options: [
          {
            __typename: "SelectedOption",
            name: "Colour",
            value: "Black"
          },
          {
            __typename: "SelectedOption",
            name: "Size",
            value: "Small"
          }
        ],
        price: {
          __typename: "Price",
          value: 21998
        }
      },
      {
        __typename: "ProductVariant",
        available: true,
        id: "variant_2",
        title: "Pink Clay/Soft Gold",
        image: null,
        options: [
          {
            __typename: "SelectedOption",
            name: "Colour",
            value: "Pink Clay/Soft Gold"
          },
          {
            __typename: "SelectedOption",
            name: "Size",
            value: "Small"
          }
        ],
        price: {
          __typename: "Price",
          value: 19998
        }
      },
      {
        __typename: "ProductVariant",
        available: false,
        id: "variant_3",
        title: "Pink Clay/Soft Gold",
        image: null,
        options: [
          {
            __typename: "SelectedOption",
            name: "Colour",
            value: "Midnight/Soft Gold"
          },
          {
            __typename: "SelectedOption",
            name: "Size",
            value: "Small"
          }
        ],
        price: {
          __typename: "Price",
          value: 32998
        }
      },

      {
        __typename: "ProductVariant",
        available: true,
        id: "variant_4",
        title: "Black",
        image: null,
        options: [
          {
            __typename: "SelectedOption",
            name: "Colour",
            value: "Black"
          },
          {
            __typename: "SelectedOption",
            name: "Size",
            value: "Medium"
          }
        ],
        price: {
          __typename: "Price",
          value: 21998
        }
      },
      {
        __typename: "ProductVariant",
        available: true,
        id: "variant_5",
        title: "Pink Clay/Soft Gold",
        image: null,
        options: [
          {
            __typename: "SelectedOption",
            name: "Colour",
            value: "Pink Clay/Soft Gold"
          },
          {
            __typename: "SelectedOption",
            name: "Size",
            value: "Medium"
          }
        ],
        price: {
          __typename: "Price",
          value: 19998
        }
      },
      {
        __typename: "ProductVariant",
        available: false,
        id: "variant_6",
        title: "Pink Clay/Soft Gold",
        image: null,
        options: [
          {
            __typename: "SelectedOption",
            name: "Colour",
            value: "Midnight/Soft Gold"
          },
          {
            __typename: "SelectedOption",
            name: "Size",
            value: "Medium"
          }
        ],
        price: {
          __typename: "Price",
          value: 32998
        }
      },

      {
        __typename: "ProductVariant",
        available: true,
        id: "variant_7",
        title: "Black",
        image: null,
        options: [
          {
            __typename: "SelectedOption",
            name: "Colour",
            value: "Black"
          },
          {
            __typename: "SelectedOption",
            name: "Size",
            value: "Large"
          }
        ],
        price: {
          __typename: "Price",
          value: 21998
        }
      },
      {
        __typename: "ProductVariant",
        available: true,
        id: "variant_8",
        title: "Pink Clay/Soft Gold",
        image: null,
        options: [
          {
            __typename: "SelectedOption",
            name: "Colour",
            value: "Pink Clay/Soft Gold"
          },
          {
            __typename: "SelectedOption",
            name: "Size",
            value: "Large"
          }
        ],
        price: {
          __typename: "Price",
          value: 19998
        }
      },
      {
        __typename: "ProductVariant",
        available: false,
        id: "variant_9",
        title: "Pink Clay/Soft Gold",
        image: null,
        options: [
          {
            __typename: "SelectedOption",
            name: "Colour",
            value: "Midnight/Soft Gold"
          },
          {
            __typename: "SelectedOption",
            name: "Size",
            value: "Large"
          }
        ],
        price: {
          __typename: "Price",
          value: 32998
        }
      }
    ],
    options: [
      {
        __typename: "ProductOption",
        name: "Colour",
        values: ["Black", "Pink Clay/Soft Gold", "Midnight/Soft Gold"]
      },
      {
        __typename: "ProductOption",
        name: "Size",
        values: ["Small", "Medium", "Large"]
      }
    ]
  }
};
